<template>
    <div class="automation-wizard-overview-container">
        <AutomationWizardOverviewDescription
            :template="template"
            class="automation-wizard-overview-container__description"
        />
        <AutomationWizardOverviewScenario
            :scenario="scenario"
            class="automation-wizard-overview-container__scenario"
        />
        <AutomationWizardOverviewBenefits :benefits="benefits" />
    </div>
</template>

<script>
import AutomationWizardOverviewBenefits from 'vcomponents/automation/templates/Wizard/Overview/AutomationWizardOverviewBenefits.vue';
import AutomationWizardOverviewDescription from 'vcomponents/automation/templates/Wizard/Overview/AutomationWizardOverviewDescription.vue';
import AutomationWizardOverviewScenario from 'vcomponents/automation/templates/Wizard/Overview/AutomationWizardOverviewScenario.vue';

export default {
    components: {
        AutomationWizardOverviewBenefits,
        AutomationWizardOverviewDescription,
        AutomationWizardOverviewScenario,
    },
    props: {
        template: {
            type: Object,
            required: true,
        },
    },
    computed: {
        overviewStep() {
            return this.template?.metadata?.wizard_steps?.find((step) => step.type === 'overview');
        },
        scenario() {
            return this.overviewStep?.scenario || [];
        },
        benefits() {
            return this.overviewStep?.benefits || [];
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-wizard-overview-container {
    display: flex;
    flex-direction: column;

    &__description {
        margin: 0 0 var(--spacing-6);
    }

    &__scenario {
        margin: 0 0 var(--spacing-4);
    }
}
</style>
